import { generateTemplateContent } from "./html_element.js";

/** ANCHOR - Busca via ajax
 * [newSearch - realiza uma busca via ajax e exibe os resultados em um template]
 * @author Eduardo de Paula Xavier
 * @objParam  [search: STRING termo a ser buscado]
 * @returns {jqXHR} Requisição cancelável; os resultados são inseridos no elemento informado.
 *  */
export function newSearch(
  search,
  {
    searchResultsListElement,
    searchResultItemTemplate,
    searchNoResultsTemplate,
    searchLoadingTemplate,
  },
  limit = 10
) {
  return $.ajax({
    url: `index.php?route=common/autocomplete/index_new&q=${search}&limit=${limit}`,
    type: "GET",
    beforeSend: function () {
      document.getElementById(searchResultsListElement).innerHTML = "";
      generateTemplateContent(
        searchLoadingTemplate,
        searchResultsListElement,
        {}
      );
    },
    success: function (data) {
      document.getElementById(searchResultsListElement).innerHTML = "";
      const products = data.products || [];
      const combos = data.combos || [];
      const outfits = data.outfits || [];

      if (
        products.length === 0 &&
        combos.length === 0 &&
        outfits.length === 0
      ) {
        generateTemplateContent(
          searchNoResultsTemplate,
          searchResultsListElement,
          {}
        );
        return;
      }

      if (products.length > 0) {
        products.forEach((product) => {
          let templateObj = {
            $product_name: product.name,
            $image: product.image,
            $price: product.price,
            $href: product.url,
          };
          generateTemplateContent(
            searchResultItemTemplate,
            searchResultsListElement,
            templateObj
          );
        });
      }

      if (combos.length > 0) {
        combos.forEach((combo) => {
          let templateObj = {
            $product_name: combo.name,
            $image: combo.image,
            $price: combo.price,
            $href: combo.url,
          };
          generateTemplateContent(
            searchResultItemTemplate,
            searchResultsListElement,
            templateObj
          );
        });
      }

      if (outfits.length > 0) {
        outfits.forEach((outfit) => {
          let templateObj = {
            $product_name: outfit.name,
            $image: outfit.image,
            $price: outfit.price,
            $href: outfit.url,
          };
          generateTemplateContent(
            searchResultItemTemplate,
            searchResultsListElement,
            templateObj
          );
        });
      }
    },
  });
}

